import React, {FocusEventHandler} from 'react';
import Select from 'react-select';
import {ReactSelectHelper, ReactSelectOnChangeCallback} from './react-select-types';

type getOptionValue<TOption, TValue extends string> = (option: TOption) => TValue;
type getOptionLabel<TOption> = (option: TOption) => string;

type SingleMappingSelectProps<TOption, TValue extends string> = {
  options: readonly TOption[];
  value: TValue | null;
  getValue: getOptionValue<TOption, TValue>;
  getLabel: getOptionLabel<TOption>;
  onChange: (value: TValue | null) => void;
  onBlur?: () => void;
  isDisabled?: boolean
};

export class SingleMappingSelect<TOption extends { [index: string]: any }, TValue extends string>
  extends React.Component<SingleMappingSelectProps<TOption, TValue>> {

  constructor(props: Readonly<SingleMappingSelectProps<TOption, TValue>>) {
    super(props);
    this.handleChange = ReactSelectHelper.nullableMappingSingle(
      '',
      props.getValue,
      this.props.onChange
    );
  }

  handleChange: ReactSelectOnChangeCallback<TOption>;

  handleBlur: FocusEventHandler = () => {
    const onBlur = this.props.onBlur;
    if (typeof onBlur === 'function')
      onBlur();
  };

  render() {
    let {options, getValue, getLabel,isDisabled} = this.props;
    let value: TOption | null = null;
    let found: TOption | undefined = undefined;
    if (this.props.value !== null)
      found = options.find(x => getValue(x) === this.props.value);
    if (found !== undefined)
      value = found;
    return (
      <Select<TOption> options={options}
                       getOptionValue={getValue}
                       getOptionLabel={getLabel}
                       value={value}
                       onChange={this.handleChange}
                       onBlur={this.handleBlur}
                       isDisabled={isDisabled === true}
                       isClearable>
      </Select>);
  }
}
